import { useCallback } from "react";
import useCatalogApi from "../../../../hooks/useCatalogApi";
import useModalLayout from "../../../../hooks/use-modal-layout/useModalLayout";

const headerConfig = { title: "Подтверждение удаления", className: "p-m-0" };

const useDeleteRecordModal = ({
    setIsVisible, record, setRecord, code, fetchData, type = "monitoring",
}) => {
    const warningText = "Это действие нельзя отменить. Запись будет удалена из системы"
        + type === "monitoring" ? " и станет недоступной для выбора &quot;Мониторинг статусов&quot;" : "";
    const { deleteRecord } = useCatalogApi();

    const handleSubmit = useCallback(async () => {
        if (!record) {
            return;
        }

        await deleteRecord(type, code, record.id);
        await fetchData();

        setIsVisible(false);
    }, [deleteRecord, type, code, record, fetchData, setIsVisible]);

    const handleClose = useCallback(() => {
        setIsVisible(false);
        setRecord(null);
    }, [setIsVisible, setRecord]);

    const footerConfig = {
        buttons: [
            {
                label: "Отмена",
                onClick: handleClose,
                classNames: ["actionButton", "cancelButton"],
            },
            {
                label: "Да, удалить",
                onClick: handleSubmit,
                classNames: ["actionButton", "deleteButton"],
            },
        ]
    };

    const { header, footer } = useModalLayout(headerConfig, footerConfig);

    return { record, handleClose, header, footer, warningText };
};

export default useDeleteRecordModal;